import { createContext, useContext, useEffect, useState } from "react";
import { Filter, useFilter } from "../common/filter";
import { Search, useSearch } from "../common/search";

const UnitNewContext = createContext();
export function UnitNew(props) {
    return <Filter>
        <Search req="unit/opts">
            <_UnitNew {...props} />
        </Search>
    </Filter>
}
function _UnitNew(props) {
    const search = useSearch()
    const filter = useFilter()
    const [unit, setUnit] = useState()

    useEffect(() => {
        if (search.selected) {
            const sel = search.selected;
            setUnit({
                ...sel,
                selectionId: sel.id,
            })
            filter.setFilter(sel.name)
        } else {
            setUnit(undefined)
        }
    }, [search.selected])

    function initUnit(name, categories = [], pts = 0, upgrades = [], models) {
        setUnit({
            name,
            categories,
            pts,
            composition: {
                upgrades,
                models,
            }
        })
    }

    return <UnitNewContext.Provider
        value={{
            initUnit,
            unit,
            updateUnit: setUnit,
        }}
        {...props}
    />
}

export function useUnitNew() {
    const { initUnit, unit, updateUnit } = useContext(UnitNewContext)

    return {
        initUnit,
        unit,
        updateUnit,
    }
}